import axios from "axios";
import { isCacheable, readCache, writeCache, isNetworkError } from "@/lib/offline";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => {
    if (isCacheable(r.config)) writeCache(r.config, r.data);
    return r;
  },
  async (error) => {
    const orig = error.config;
    if (orig && isNetworkError(error) && isCacheable(orig)) {
      const cached = readCache(orig);
      if (cached !== undefined) return { data: cached, status: 200, config: orig, headers: {}, offline: true };
    }
    if (error.response?.status === 401 && orig && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(orig);
      } catch (e) {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fileUrl = (id) => `${API}/files/${id}`;
